import type { NostrEvent } from '@nostrify/nostrify';
import { useNostr } from '@nostrify/react';
import { useQuery } from '@tanstack/react-query';

/**
 * Fetches a single event by id. Optionally constrain by author (recommended
 * when the id came from an nevent that carries an author hint).
 */
export function useEvent(id: string | undefined, author?: string) {
  const { nostr } = useNostr();

  return useQuery<NostrEvent | null>({
    queryKey: ['event', id ?? '', author ?? ''],
    queryFn: async ({ signal }) => {
      if (!id) return null;
      const [event] = await nostr.query(
        [{ ids: [id], ...(author ? { authors: [author] } : {}), limit: 1 }],
        { signal: AbortSignal.any([signal, AbortSignal.timeout(5000)]) },
      );
      return event ?? null;
    },
    enabled: !!id,
  });
}
